import { IPeerRecoveryConfiguration } from '../../../FrontApplet/Management/PeerRecovery/IPeerRecovery';
import { EmptyObject } from '../../EmptyObject';

export type ManagementPeerRecoveryRequests = ManagementPeerRecoverySetRequest | ManagementPeerRecoveryGetRequest;

export const ManagementPeerRecoverySetRequest = 'sos.Monitoring.Management.ManagementPeerRecoverySetRequest';
export interface ManagementPeerRecoverySetRequest {
	type: typeof ManagementPeerRecoverySetRequest;
	configuration: IPeerRecoveryConfiguration;
}

export const ManagementPeerRecoverySetResult = 'sos.Monitoring.Management.ManagementPeerRecoverySetResult';
export interface ManagementPeerRecoverySetResult {
	type: typeof ManagementPeerRecoverySetResult;
	result: EmptyObject;
}

export const ManagementPeerRecoveryGetRequest = 'sos.Monitoring.Management.ManagementPeerRecoveryGetRequest';
export interface ManagementPeerRecoveryGetRequest {
	type: typeof ManagementPeerRecoveryGetRequest;
}

export const ManagementPeerRecoveryGetResult = 'sos.Monitoring.Management.ManagementPeerRecoveryGetResult';
export interface ManagementPeerRecoveryGetResult {
	type: typeof ManagementPeerRecoveryGetResult;
	result: IPeerRecoveryConfiguration;
}
